<template>
  <div class="team-member-list-item">
    <div v-if="teamMember.image" class="team-member-list-item__image-container">
      <picture-basic
        v-bind="
          getPictureBindings(teamMember.image, {
            ratio: 1,
            contain: false,
            preset: 'team',
          })
        "
        class="team-member-list-item__image has-marg-bottom-m"
      />
    </div>
    <h4 class="team-member-list-item__name title is-3 is-up">
      {{ teamMember.title }}
    </h4>
    <div v-if="teamMember.subtitle" class="team-member-list-item__role title is-up is-strong has-marg-top-xxs">
      {{ teamMember.subtitle }}
    </div>
    <div v-if="teamMember.bio" class="team-member-list-item__bio has-marg-top-m">
      <bard as-content :content="teamMember.bio" />
    </div>
    <div v-if="teamMember.email" class="team-member-list-item__email has-marg-top-s">
      <pt-icon-mail />
      <a :href="emailHref" class="link-primary is-3">
        <span class="link-primary__label">
          {{ teamMember.email }}
        </span>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatEmailHref } from '@/utils/formatters';
import { useImages } from '~/composables/images';
import PtIconMail from '~/components/global/icons/PtIconMail.vue';
import Bard from '~/components/content/Bard.vue';
import PictureBasic from '~/components/global/images/PictureBasic.vue';

const props = defineProps({
  teamMember: {
    type: Object,
    required: true,
  },
});

const { getPictureBindings } = useImages();

const emailHref = computed(() => formatEmailHref(props.teamMember.email));
</script>
